module.exports = __webpack_public_path__ + "static/media/h.903a0889.svg";